export default "__VITE_ASSET__klvC5SPN__"